import { render, staticRenderFns } from "./Unbinding.vue?vue&type=template&id=24f057e6&scoped=true"
import script from "./Unbinding.vue?vue&type=script&lang=js"
export * from "./Unbinding.vue?vue&type=script&lang=js"
import style0 from "./Unbinding.vue?vue&type=style&index=0&id=24f057e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f057e6",
  null
  
)

export default component.exports